export default __webpack_public_path__ + "static/media/plus-icon.c4ceb494.svg";